import { Controller } from "@hotwired/stimulus"

// Store tier editor (TMS-1245): shows what each pack price works out to per copy, next
// to the single-copy price, as staff type — so a bulk discount is visible, not accidental.
export default class extends Controller {
  static targets = ["quantity", "price", "compare"]

  connect() {
    this.update()
  }

  update() {
    const quantity = parseInt(this.quantityTarget.value, 10)

    this.compareTargets.forEach((compare) => {
      const tier = compare.dataset.priceTier
      const input = this.priceTargets.find((price) => price.dataset.priceTier === tier)
      const output = compare.querySelector("[data-role='per-copy']")
      const packPrice = parseFloat(input?.value)

      if (!quantity || quantity < 1 || Number.isNaN(packPrice)) {
        output.textContent = "—"
        compare.classList.remove("is-higher")
        return
      }

      const perCopyCents = Math.round((packPrice * 100) / quantity)
      output.textContent = this.format(perCopyCents)
      compare.classList.toggle("is-higher", perCopyCents > parseInt(compare.dataset.singleCents, 10))
    })
  }

  format(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100)
  }
}
